import { ImageryData } from "./types";

export const IMAGERY_DATA: ImageryData[] = [
  {
    url: 'https://gisportal.horrycounty.org/image/rest/services/Imagery/Aerials1998/ImageServer',
    label: '1998',
    type: "ImageryLayer",
  },
  {
    url: 'https://gisportal.horrycounty.org/image/rest/services/Imagery/Aerials2001/ImageServer',
    label: '2001',
    type: "ImageryLayer",
  },
  {
    url: 'https://gisportal.horrycounty.org/image/rest/services/Imagery/Aerials2005/ImageServer',
    label: '2005',
    type: "ImageryLayer",
  },
  {
    url: 'https://gisportal.horrycounty.org/image/rest/services/Imagery/Aerials2008/ImageServer',
    label: '2008',
    type: "ImageryLayer",
  },
  {
    url: 'https://gisportal.horrycounty.org/image/rest/services/Imagery/Aerials2009/ImageServer',
    label: '2009',
    type: "ImageryLayer",
  },
  {
    url: 'https://gisportal.horrycounty.org/image/rest/services/Imagery/Aerials2010/ImageServer',
    label: '2010',
    type: "ImageryLayer",
  },
  {
    url: 'https://gisportal.horrycounty.org/image/rest/services/Imagery/Aerials2014/ImageServer',
    label: '2014',
    type: "ImageryLayer",
  },
  {
    url: 'https://gisportal.horrycounty.org/image/rest/services/Imagery/Aerials2017/ImageServer',
    label: '2017',
    type: "ImageryLayer",
  },
  {
    url: 'https://gisportal.horrycounty.org/image/rest/services/Imagery/Aerials2020/ImageServer',
    label: '2020',
    type: "ImageryLayer",
  },
  // {
  //   url: 'https://gisportal.horrycounty.org/image/rest/services/Imagery/Aerials2023Cache/ImageServer',
  //   label: '2023',
  //   type: "TileLayer",
  // },
  {
    url: 'https://gisportal.horrycounty.org/image/rest/services/Imagery/Aerials2023/ImageServer',
    label: '2023',
    type: "ImageryLayer",
  }
]